import Vue from 'vue'
import fr from 'vee-validate/dist/locale/fr'
import VeeValidate, { Validator } from 'vee-validate'

Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields',
  delay: 250
})

Validator.localize('fr', fr)

Vue.mixin({
  $_veeValidate: {
    validator: 'new'
  },
  methods: {
    async formHasErrors () {
      const valid = await this.$validator.validateAll()
      if (valid) {
        this.$validator.pause()
      }
      return !valid
    }
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/validation.js